import { IConfigService } from './configServiceTypes';

export class ConfigService implements IConfigService {
	public isStub(): boolean {
		return !(window as any).mp;
	}

	public isDevelopment(): boolean {
		return import.meta.env.MODE === 'development';
	}

	public getBackendUrl(): string {
		return import.meta.env.VITE_BACKEND_URL;
	}
}
